export const iconFontAwesomeHouseholdFan = (
	<i className="fa-solid fa-fan"></i>
);
